/**
 * @generated SignedSource<<21589464bffc3a059e18b1f9a936ad5b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type processDefinitionsQueryXmlQuery$variables = {
  id: string;
};
export type processDefinitionsQueryXmlQuery$data = {
  readonly getProcessDefinition: {
    readonly definitionName: string;
    readonly definitionXml: string;
  } | null | undefined;
};
export type processDefinitionsQueryXmlQuery = {
  response: processDefinitionsQueryXmlQuery$data;
  variables: processDefinitionsQueryXmlQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "definitionName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "definitionXml",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "processDefinitionsQueryXmlQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProcessDefinition",
        "kind": "LinkedField",
        "name": "getProcessDefinition",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "processDefinitionsQueryXmlQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProcessDefinition",
        "kind": "LinkedField",
        "name": "getProcessDefinition",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a505b7cbd1a158e5409e9d884cb68374",
    "id": null,
    "metadata": {},
    "name": "processDefinitionsQueryXmlQuery",
    "operationKind": "query",
    "text": "query processDefinitionsQueryXmlQuery(\n  $id: ID!\n) {\n  getProcessDefinition(id: $id) {\n    definitionName\n    definitionXml\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5c32bb3238c4f6b707dbf45227e0184a";

export default node;
